var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.989 511.989",
    height: 512,
    viewBox: "0 0 511.989 511.989",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.995 90c-74.991 0-136 61.01-136 136s61.009 136 136 136c74.99 0 136-61.01 136-136s-61.01-136-136-136zm15 241h-30v-30h30zm0-91.882v31.882h-30v-60h15c16.817 0 30.5-13.683 30.5-30.5s-13.683-30.5-30.5-30.5c-16.818 0-30.5 13.683-30.5 30.5h-30c0-33.359 27.14-60.5 60.5-60.5 33.359 0 60.5 27.141 60.5 60.5 0 28.184-19.372 51.929-45.5 58.618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.801 66.193c-42.686-42.685-99.439-66.193-159.806-66.193s-117.121 23.508-159.807 66.193c-42.685 42.687-66.193 99.44-66.193 159.807 0 101.778 67.747 190.656 165.325 217.756l60.675 68.233 60.675-68.233c97.579-27.1 165.325-115.978 165.325-217.756 0-60.367-23.508-117.12-66.194-159.807zm-159.806 325.807c-91.533 0-166-74.468-166-166s74.467-166 166-166c91.532 0 166 74.468 166 166s-74.468 166-166 166z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.fb8ff33975a0d5b1b84c4f235ff2310d.svg";
export { ForwardRef as ReactComponent };